import { computed, defineComponent, useCssModule } from '@nuxtjs/composition-api';
import { DEFAULT_DROPDOWN, DEFAULT_SEARCH } from '.';
export default defineComponent({
    name: 'Filters',
    props: {
        dropdown: {
            default: () => ({}),
            type: Object,
        },
        search: {
            default: () => ({}),
            type: Object,
        },
        tabs: {
            default: () => ({}),
            type: Object,
        },
    },
    setup(props) {
        /**
         * CSS Modules.
         */
        const css = useCssModule();
        const currentDropdown = computed(() => {
            return {
                ...DEFAULT_DROPDOWN,
                ...props.dropdown,
            };
        });
        const currentSearch = computed(() => {
            return {
                ...DEFAULT_SEARCH,
                ...props.search,
            };
        });
        return {
            css,
            currentDropdown,
            currentSearch,
        };
    },
});
